export default "__VITE_ASSET__ecd3eed6__"